import $ from 'jquery';

export default function edvBlockFullWidth() {

        function adjustHeight() {
            let contentHeight = $('.text-full-width__content').height() + 160;
            $('.text-full-width-container').height(contentHeight);
        }
        if(window.innerWidth > 992) {
            adjustHeight();
        }

        $(window).resize(function() {
            if(window.innerWidth > 992) {
                adjustHeight();
            }
            if(window.innerWidth <= 992) {
                $('.text-full-width-container').height('100%');
            }

        });

}